import React, { useEffect, useState, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../utils/fetchWithAuth';
import { useUser } from '../context/UserContext';
import Button  from '../components/UI/Button';
// Флаг для отслеживания инициализации сканера
let scannerInstance = null;

export const QRScannerPage = () => {
	const { logout } = useUser();
    const [scanResult, setScanResult] = useState(null);
    const [scanStatus, setScanStatus] = useState('🔍 Ожидание QR-кода...');
    const navigate = useNavigate();
    const lastErrorTime = useRef(Date.now());
    const readerRef = useRef(null);

    // Функция для безопасной очистки сканера
    const safeCleanupScanner = () => {
        try {
            if (scannerInstance) {
                scannerInstance.clear();
                scannerInstance = null;
            }
        } catch (error) {
            console.error('Ошибка при очистке сканера:', error);
        }
    };

    // Функция для инициализации сканера с таймаутом
    const initializeScanner = () => {
        // Если сканер уже инициализирован, не создаем новый
        if (scannerInstance) return;

        // Проверяем, что элемент reader существует
        if (!readerRef.current) return;

        try {
            scannerInstance = new Html5QrcodeScanner('reader', {
                qrbox: { width: 250, height: 250 },
                fps: 5,
                rememberLastUsedCamera: false,
            });

            scannerInstance.render(
                (result) => {
                    setScanResult(result);
                    setScanStatus('✅ QR-код успешно прочитан');
                    handleScan(result);
                },
                (error) => {
                    if (error.name === 'NotFoundException') {
                        const now = Date.now();
                        if (now - lastErrorTime.current > 2000) {
                            setScanStatus('🔍 QR-код не найден. Попробуйте навести снова...');
                            lastErrorTime.current = now;
                        }
                    }
                }
            );
        } catch (error) {
            console.error('Ошибка при инициализации сканера:', error);
        }
    };

    // Функция для перезапуска сканера
    const restartScanner = () => {
        safeCleanupScanner();
        setScanStatus('🔍 Ожидание QR-кода...');
        setTimeout(() => {
            initializeScanner();
        }, 500);
    };

    useEffect(() => {
        // Используем setTimeout чтобы убедиться, что DOM полностью загружен
        const timerId = setTimeout(() => {
            initializeScanner();
        }, 500);

        return () => {
            clearTimeout(timerId);
            safeCleanupScanner();
        };
    }, []);

    const handleScan = async (result) => {
        try {
            // Сначала очищаем сканер
            safeCleanupScanner();

            const parsed = JSON.parse(result);
            const { qrId, type } = parsed;
    
            const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/qr/scan`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ qrId }),
            }, logout);
    
            const data = await response.json();
    
            switch (data.type) {
                case 'product':
                    navigate(`/products/${data.object._id}`);
                    break;
                case 'order':
                    navigate(`/orders/${data.object._id}`);
                    break;
                default:
                    console.error('Неизвестный тип объекта:', data.type);
                    setScanStatus('❌ Неизвестный тип QR-кода');
            }
        } catch (error) {
            console.error('Ошибка при обработке QR:', error);
            setScanStatus('❌ Ошибка при обработке QR-кода' + error.message);
            // Перезапускаем сканер через 3 секунды после ошибки
            setTimeout(restartScanner, 3000);
        }
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Сканирование QR кода</h1>
            <div id="reader" ref={readerRef} className="w-full max-w-md mx-auto"></div>
            <div className="mt-4 text-sm text-gray-500">{scanStatus}</div>
            {/* {scanResult && (
                <div className="mt-4 p-4 bg-[#3E3E42] rounded">
                    <p>Отсканировано: {scanResult}</p>
                    <div className="flex gap-2 mt-2">
                        <Button variant="ghost" size="sm" onClick={() => {
                            setScanResult(null);
                            restartScanner();
                        }}>
                            Закрыть и сканировать снова
                        </Button>
                    </div>
                </div>
            )} */}
        </div>
    );
};
